import {
 
  Directive,
  ViewContainerRef,
} from "@angular/core";
import { AccountingGenerateComponent } from "src/components/general components/accounting-generate/accounting-generate.component";
import { LoadFormComponent } from "src/components/general components/load-form/load-form.component";
import { ReporthtmlFormComponent } from "src/components/general components/reporthtml-form/reporthtml-form.component";
import { GenericTableAnagraphAnagraph } from "src/model/class/general classes/generic-table-anagraph-anagraph";

/**
 * This Directive is used in order to draw (on the right side of the screen) a sub-component "Anagraph" displaying the "information" 
 * associated with the currently selected object from the list contained in the "table" sub-component (on the left side of the screen).
  It does so based on the selector passed throug its "drawAnagraphComponent(...)" method.
 */
@Directive({
    selector: "[appStructureTableAnagraph_Anagraph]",
    standalone: false
})
export class StructureTableAnagraph_AnagraphDirective {
  private componentInstanceRef: GenericTableAnagraphAnagraph = null;

  constructor(
    private viewContainerRef: ViewContainerRef,
   
  ) {
    viewContainerRef.constructor.name === "ViewContainerRef_"; // true
  }

  /**
   * Send the current objet to the anagraph component
   * @param currentObject
   */
  public ChangeCurrentObject(currentObject: any): void {
    this.componentInstanceRef.CurrentObject = currentObject;
    this.componentInstanceRef.OnChanges();
  }

  /**
   * Draw the component displaying the information on the right part of the screen with the list of object in the left part of the screen
   * @param tableToLoad selector of the anagraph table component to load
   */
  public drawAnagraphComponent(anagraphComponent: string): void {
    const componentsHostViewRef = this.viewContainerRef;

    componentsHostViewRef.clear();

    let compFactory: any = null;

    switch (anagraphComponent) {
      case "app-reporthtml-form":
        compFactory = this.viewContainerRef.createComponent(
          ReporthtmlFormComponent
        );
        break;
      case "app-accounting-generate":
        compFactory = this.viewContainerRef.createComponent(
          AccountingGenerateComponent
        );
        break;
      case "app-load-form":
        compFactory =
          this.viewContainerRef.createComponent(
            LoadFormComponent
          );
        break;
      
    }

    if (compFactory != null) {
      const componentRef = componentsHostViewRef.createComponent(compFactory);
      this.componentInstanceRef =
        componentRef.instance as GenericTableAnagraphAnagraph;
    }
  }
}
